// A document's name as the file the person has ("ARCHIVO TX BANCO"), with what it is also called
// drawn smaller after it ("conciliacion e pago") — the names file writes that part between ().
import { partesDeNombre } from "../../../utils/cierreNombres";

export function NombreDeArchivo({ nombre }) {
  const { principal, aparte } = partesDeNombre(nombre);
  return (
    <>
      {principal}
      {aparte ? <span className="ml-1 text-[11px] font-normal text-brinks-muted-foreground">({aparte})</span> : null}
    </>
  );
}

export default NombreDeArchivo;
